<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2 side-frame-success">
      <span>NO: {{ reportBudgetNo }}</span>
      <el-divider direction="vertical"></el-divider>
      <el-tag
          size="mini"
          :type="
            formData.reportBudgetStatus === 'D'
              ? 'info'
              : formData.reportBudgetStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ formData.v_reportBudgetStatus }}
        </el-tag>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyTime }}
      </span>
    </div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('from_label_department_name') || '部门名称'"
            prop="depCode"
          >
            <dict-select
              size="mini"
              clearable
              v-model="formData.depCode"
              url="/sys/common/dict/depPrimary"
              :placeholder="$l('from_label_ps_department_name') || '请选择部门'"
              filterable
              :selectedLabel.sync="formData.depName"
              @change="updateTeamCode"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('from_label_team_name') || '团队名称'"
            ref="teamForm"
          >
            <dict-select
              clearable
              v-model="formData.teamCode"
              url="/sys/common/dict/depByParentCode"
              :placeholder="$l('from_label_ps_team_name') || '请选择所属团队'"
              :body="teamparams"
              filterable
              :disabled="!formData.depName"
              :selectedLabel.sync="formData.teamName"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('from_label_budget_year') || '预算年度'"
            prop="budgetYear"
          >
            <el-date-picker
              v-model="formData.budgetYear"
              value-format="yyyy"
              type="year"
              :placeholder="$l('from_label_ps_budget_year') || '选择预算年度'"
              style="width: 100%"
              size="mini"
              :picker-options="pickerOptions"
              @change="changeDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.label_beginDate') || '开始日期'"
            prop="beginDate"
          >
            <el-date-picker
              v-model="formData.beginDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :picker-options="beginDatePicker"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.label_endDate') || '结束日期'"
            prop="endDate"
          >
            <el-date-picker
              v-model="formData.endDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePicker"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('from_label_budget_amount') || '预算总额'"
            prop="v_totBudget"
          >
            <el-input
              v-model="formData.v_totBudget"
              readonly
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
const initFrom = {
  reportBudgetCode: '',
  depCode: '',
  depName: '',
  teamCode: '',
  teamName: '',
  budgetYear: '',
  beginDate: '',
  endDate: '',
  totBudget: '',
  v_totBudget: '',
  companyCode: '',
  v_reportBudgetStatus: '',
  createByName: '',
  createTime: '',
  modifyByName: '',
  modifyTime: '',
  budgetType: 'Q',
}
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    orderCode: { type: String, default: '' },
    orderPackingCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
    reportBudgetNo: { type: String, default: '' },
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.formData = {
            reportBudgetCode: this.form.reportBudgetCode,
            depCode: this.form.depCode ? this.form.depCode : '',
            depName: this.form.depName ? this.form.depName : '',
            teamCode: this.form.teamCode,
            teamName: this.form.teamName,
            budgetYear: this.form.budgetYear,
            beginDate: this.form.beginDate,
            endDate: this.form.endDate,
            totBudget: this.form.totBudget,
            v_totBudget: this.form.v_totBudget,
            companyCode: this.form.companyCode,
            v_reportBudgetStatus: this.form.v_reportBudgetStatus,
            reportBudgetStatus: this.form.reportBudgetStatus,
            createByName: this.form.createByName,
            createTime: this.form.createTime,
            modifyByName: this.form.modifyByName,
            modifyTime: this.form.modifyTime,
            budgetType: 'Q',
          }
        }
      },
      immediate: true,
    },
    'formData.depCode'() {
      this.teamparams = { parentCode: this.formData.depCode }
    },
    'formData.budgetType'() {
      this.updateBudgetType()
    },
  },
  data() {
    return {
      backDialogVisible: false,
      teamparams: { parentCode: '' },
      formData: { ...initFrom },
      tableData: [],
      beginDatePicker: this.endDate(),
      endDatePicker: this.beginDate(),
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        disabledDate: (time) => {
          let maxYear = new Date().getFullYear() + 1
          return time.getTime() > new Date(JSON.stringify(maxYear))
        },
      },
      rules: {
        // endDate: [
        //   {
        //     required: true,
        //     message: '请选择结束日期',
        //     trigger: 'change'
        //   }
        // ],
        // beginDate: [
        //   {
        //     required: true,
        //     message: '请选择开始日期',
        //     trigger: 'change'
        //   }
        // ],
        budgetYear: [
          {
            required: true,
            message: this.$l('from_label_ps_budget_year') || '选择预算年度',
            trigger: 'change',
          },
        ],
        totBudget: [
          {
            required: true,
            message: '请输入预算总额',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('from_label_ps_department_name') || '请选择部门',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async getFormData() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      return this.formData
    },

    //日期限制
    endDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.formData.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    beginDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.formData.beginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    updateTotBudget(val) {
      this.formData.totBudget = val
    },
    updateTeamCode() {
      this.formData.teamCode = ''
      this.formData.teamName = ''
    },
    updateBudgetType() {
      this.$emit('updateBudgetType', this.formData.budgetType)
    },
    changeDate() {
      this.formData.beginDate = this.formData.budgetYear + '-01-01 00:00:00'
      this.formData.endDate = this.formData.budgetYear + '-12-31 00:00:00'
    },
  },
}
</script>
